module.exports = __webpack_public_path__ + "static/media/service-5_old.cea258ab.jpg";